(()=>{const reduced=matchMedia('(prefers-reduced-motion: reduce)'),fine=matchMedia('(hover:hover) and (pointer:fine)');document.addEventListener('pointermove',e=>{if(reduced.matches||!fine.matches||document.body.dataset.lpcMotion==='false')return;const vault=e.target.closest('[data-lpc-tilt]');if(!vault)return;const image=vault.querySelector('.hero-product'),r=vault.getBoundingClientRect();image.style.setProperty('--lpc-ry',Math.max(-3,Math.min(3,(e.clientX-r.left-r.width/2)/r.width*6))+'deg');image.style.setProperty('--lpc-rx',Math.max(-2,Math.min(2,-(e.clientY-r.top-r.height/2)/r.height*4))+'deg');});document.addEventListener('pointerout',e=>{const vault=e.target.closest('[data-lpc-tilt]');if(vault&&!vault.contains(e.relatedTarget)){const image=vault.querySelector('.hero-product');image.style.setProperty('--lpc-ry','0deg');image.style.setProperty('--lpc-rx','0deg');}});})();
(()=>{function setup(){const sticky=document.querySelector('sticky-add-to-cart'),buy=document.querySelector('.product-details .buy-buttons-block');if(!sticky||!buy||sticky.dataset.lpcWatching)return;sticky.dataset.lpcWatching='true';const update=()=>{sticky.dataset.lpcBelow=String(matchMedia('(max-width:749px)').matches&&buy.getBoundingClientRect().top>=innerHeight&&!customElements.get('shopify-chat'));};new IntersectionObserver(update).observe(buy);window.addEventListener('resize',update,{passive:true});customElements.whenDefined('shopify-chat').then(update);update();}setup();document.addEventListener('shopify:section:load',setup);})();
(() => {
  const controllers = new Map(), reduced = matchMedia('(prefers-reduced-motion: reduce)');
  function init(root) {
    if (controllers.has(root)) return;
    const slides = [...root.querySelectorAll('template[data-lpc-slide]')];
    if (slides.length < 2) return;
    const mount = root.querySelector('[data-lpc-mount]'), controls = root.querySelector('.lpc-rotator-controls');
    const toggle = root.querySelector('[data-lpc-toggle]'), counter = root.querySelector('[data-lpc-counter]');
    const announce = root.querySelector('[data-lpc-announcement]'), cached = new Map();
    let index=0, timer, prefetchTimer, hovered=false, focused=false, visible=false, disposed=false, firstReady=false, sequence=0;
    let paused=reduced.matches || root.dataset.autoplay!=='true' || document.body.dataset.lpcMotion==='false';
    const interval=Math.max(5000,Number(root.dataset.interval)||7000);
    controls.hidden=false;
    const eligible=()=>!disposed && firstReady && visible && !paused && !hovered && !focused && !document.hidden;
    function preload(i) {
      if(cached.has(i))return cached.get(i);
      const source=slides[i].content.querySelector('img');
      if(!source)return Promise.resolve(true);
      const img=new Image();
      img.fetchPriority='low';
      if(source.sizes)img.sizes=source.sizes;
      if(source.srcset)img.srcset=source.srcset;
      img.src=source.src;
      const ready=img.decode().then(()=>true,()=>{cached.delete(i);return false;});
      cached.set(i,ready);
      return ready;
    }
    function schedule() {
      clearTimeout(timer);clearTimeout(prefetchTimer);
      toggle.textContent=paused?toggle.dataset.play:toggle.dataset.pause;
      toggle.setAttribute('aria-pressed',String(paused));
      if(!eligible())return;
      const connection=navigator.connection;
      if(!connection?.saveData && !['slow-2g','2g'].includes(connection?.effectiveType)) {
        prefetchTimer=setTimeout(()=>{if(eligible())preload((index+1)%slides.length);},Math.min(3500,interval/2));
      }
      timer=setTimeout(()=>show(index+1,false),interval);
    }
    async function show(next,manual) {
      clearTimeout(timer);clearTimeout(prefetchTimer);
      const ticket=++sequence,target=(next+slides.length)%slides.length;
      const loaded=await preload(target);
      if(disposed||ticket!==sequence)return;
      if(!loaded||(!manual&&!eligible())){schedule();return;}
      index=target;
      mount.replaceChildren(slides[index].content.cloneNode(true));
      mount.firstElementChild.classList.add('lpc-slide-enter');
      counter.textContent=`${index+1} / ${slides.length}`;
      if(manual)announce.textContent=mount.querySelector('h2').textContent.trim();
      schedule();
    }
    root.querySelector('[data-lpc-next]').addEventListener('click',()=>show(index+1,true));
    root.querySelector('[data-lpc-prev]').addEventListener('click',()=>show(index-1,true));
    toggle.addEventListener('click',()=>{paused=!paused;schedule();});
    root.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse'){hovered=true;schedule();}});
    root.addEventListener('pointerleave',e=>{if(e.pointerType==='mouse'){hovered=false;schedule();}});
    root.addEventListener('focusin',()=>{focused=true;schedule();});
    root.addEventListener('focusout',()=>requestAnimationFrame(()=>{focused=root.contains(document.activeElement);schedule();}));
    const visibility=()=>schedule(),motion=()=>{if(reduced.matches)paused=true;schedule();};
    document.addEventListener('visibilitychange',visibility);
    reduced.addEventListener('change',motion);
    const observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting&&entries[0].intersectionRatio>=.5;schedule();},{threshold:[0,.5]});
    observer.observe(mount);
    const firstImage=mount.querySelector('img');
    const ready=firstImage?firstImage.decode().catch(()=>{}):Promise.resolve();
    ready.then(()=>{if(!disposed){firstReady=true;root.dataset.lpcReady='true';schedule();}});
    counter.textContent=`1 / ${slides.length}`;schedule();
    controllers.set(root,()=>{disposed=true;++sequence;clearTimeout(timer);clearTimeout(prefetchTimer);observer.disconnect();document.removeEventListener('visibilitychange',visibility);reduced.removeEventListener('change',motion);controllers.delete(root);});
  }
  const setup=()=>document.querySelectorAll('[data-lpc-rotator]').forEach(init);
  setup();
  document.addEventListener('shopify:section:load',setup);
  document.addEventListener('shopify:section:unload',event=>controllers.forEach((dispose,root)=>{if(event.target.contains(root))dispose();}));
  document.addEventListener('click',event=>{
    const button=event.target.closest('[data-lpc-banner-toggle]');
    if(!button)return;
    const banner=button.closest('[data-lpc-banner]'),paused=banner.dataset.paused!=='true';
    banner.dataset.paused=String(paused);button.setAttribute('aria-pressed',String(paused));
    button.setAttribute('aria-label',paused?button.dataset.play:button.dataset.pause);
    button.firstElementChild.textContent=paused?'▶':'Ⅱ';
  });
})();

(() => {
  const instances=new Map(),reduced=matchMedia('(prefers-reduced-motion: reduce)'),fine=matchMedia('(hover:hover) and (pointer:fine)');
  function init(root){
    if(instances.has(root))return;
    const rail=root.querySelector('[data-grails-rail]'),cards=[...root.querySelectorAll('[data-grail-card]')];
    const tools=root.querySelector('[data-grails-tools]'),counter=root.querySelector('[data-grails-counter]');
    if(!rail||!cards.length||!tools)return;
    tools.hidden=false;
    const prev=tools.querySelector('[data-grails-step="-1"]'),next=tools.querySelector('[data-grails-step="1"]');
    let frame=0,imagesReady=false,disposed=false;
    const firstImage=cards[0].querySelector('img');
    // Finish the LCP candidate before bringing nearby slab photos into the DOM.
    // Titles, prices, links and no-script photos remain server rendered.
    (firstImage?firstImage.decode().catch(()=>{}):Promise.resolve()).then(()=>{
      if(disposed)return;imagesReady=true;update();
    });
    function update(){
      frame=0;
      const bounds=rail.getBoundingClientRect(),visible=[];
      cards.forEach((card,i)=>{
        const r=card.getBoundingClientRect();
        if(r.right>bounds.left+8&&r.left<bounds.right-8)visible.push(i+1);
        const template=card.querySelector('template[data-grail-image]');
        if(imagesReady&&template&&r.right>bounds.left-80&&r.left<bounds.right+80){
          const fragment=template.content.cloneNode(true),image=fragment.querySelector('img');
          if(image)image.loading='eager';
          template.replaceWith(fragment);
        }
      });
      counter.textContent=visible.length>1?`${visible[0]}–${visible.at(-1)} / ${cards.length}`:`${visible[0]||1} / ${cards.length}`;
      prev.disabled=rail.scrollLeft<=2;
      next.disabled=rail.scrollLeft>=rail.scrollWidth-rail.clientWidth-3;
    }
    const onScroll=()=>{if(!frame)frame=requestAnimationFrame(update);};
    const onClick=e=>{
      const button=e.target.closest('[data-grails-step]');if(!button)return;
      const width=cards[0].getBoundingClientRect().width+parseFloat(getComputedStyle(rail).columnGap||0);
      rail.scrollBy({left:Number(button.dataset.grailsStep)*width,behavior:reduced.matches||document.body.dataset.lpcMotion==='false'?'instant':'smooth'});
    };
    rail.addEventListener('scroll',onScroll,{passive:true});
    tools.addEventListener('click',onClick);
    const observer=new ResizeObserver(update);observer.observe(rail);update();
    instances.set(root,()=>{disposed=true;rail.removeEventListener('scroll',onScroll);tools.removeEventListener('click',onClick);observer.disconnect();cancelAnimationFrame(frame);instances.delete(root);});
  }
  const setup=()=>document.querySelectorAll('[data-lpc-grails]').forEach(init);
  setup();document.addEventListener('shopify:section:load',setup);
  document.addEventListener('shopify:section:unload',e=>instances.forEach((dispose,root)=>{if(e.target.contains(root))dispose();}));
  document.addEventListener('pointermove',e=>{
    if(e.pointerType!=='mouse'||!fine.matches||reduced.matches||document.body.dataset.lpcMotion==='false')return;
    const photo=e.target.closest('.lpc-grail-photo');if(!photo)return;
    const box=photo.getBoundingClientRect();
    photo.style.setProperty('--slab-x',`${-(e.clientY-box.top-box.height/2)/box.height*3}deg`);
    photo.style.setProperty('--slab-y',`${(e.clientX-box.left-box.width/2)/box.width*4}deg`);
  },{passive:true});
  document.addEventListener('pointerout',e=>{
    const photo=e.target.closest('.lpc-grail-photo');
    if(photo&&!photo.contains(e.relatedTarget)){photo.style.setProperty('--slab-x','0deg');photo.style.setProperty('--slab-y','0deg');}
  },{passive:true});
})();
